import styles from './index.module.scss'
import GoogleplayStoreImg from '../../assets/images/share/googleplay.png'

const GooglePlayButton = () => (
    <img
        onClick={() =>
            window.open(
                process.env.REACT_APP_GOOGLEPLAYSTORE ||
                    'https://play.google.com/store/apps/details?id=com.kepple.sparkreliefteachers'
            )
        }
        src={GoogleplayStoreImg}
        alt="GoogleplayStoreImg"
        className={styles.GoogleplayStoreImg}
    />
)

export default GooglePlayButton
